<!-- components/BindDialogA.vue -->
<template>
  <el-dialog
    :model-value="visible"
    title="绑定免喜门店"
    width="600px"
    :close-on-click-modal="false"
    @update:model-value="handleClose"
    @closed="resetForm"
  >
    <div class="dialog-content">
      <div class="station-info">
        站点：
        <strong>{{ siteName }}</strong>
      </div>

      <div class="tips-text">
        请先在免喜生活APP完成门店注册。填写入门店编号，点击查询门店信息，核对系统展示的门店名称与地址后确认绑定。
      </div>

      <el-form :model="formData" ref="formRef" label-width="120px" class="bind-form">
        <el-form-item
          label="免喜门店编号"
          prop="storeCode"
          :rules="[{ required: true, message: '请输入门店编号', trigger: 'blur' }]"
        >
          <el-input v-model="formData.storeCode" placeholder="如 TUXI39401799302" clearable />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="queryLoading" @click="handleQueryStore">查询门店信息</el-button>
          <span class="inline-tips">先查询再确认，避免误绑</span>
        </el-form-item>
      </el-form>
    </div>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="handleClose(false)">关 闭</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue'
import { ElMessage } from 'element-plus'
import { useCurrentAppInstance } from '@zto/zpage-runtime'
const app = useCurrentAppInstance()

const props = defineProps({
  visible: { type: Boolean, default: false },
  siteName: { type: String, default: '' },
  siteCode: { type: String, default: '' }
})

const emit = defineEmits(['update:visible', 'query-success'])

const formRef = ref()
const queryLoading = ref(false)
const formData = reactive({
  storeCode: ''
})

// 触发关闭
const handleClose = (val: boolean) => {
  emit('update:visible', val)
}

// 重置表单
const resetForm = () => {
  if (formRef.value) formRef.value.resetFields()
}

// 查询操作
const handleQueryStore = async () => {
  if (!formRef.value) return
  await formRef.value.validate(async (valid: any) => {
    if (valid) {
      queryLoading.value = true
      try {
        // 【在此替换为真实的查询API】
        // const res = await api.queryStoreInfo(formData.storeCode)
        const res = await queryStoreInfoByCode(formData.storeCode)

        // 查询成功，关闭弹窗A，并将数据抛给父组件
        emit('update:visible', false)
        emit('query-success', res)
      } finally {
        queryLoading.value = false
      }
    }
  })
}

const queryStoreInfoByCode = (code: string) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await app.request({
        api: 'sys/admin/site/getStoreInfoForBind',
        params: { siteCode: props.siteCode, depotCode: code }
      })
      if (res) {
        app.ui.showMessage({
          type: 'success',
          message: `操作成功`
        })
        resolve(res)
      } else {
        reject({ message: res.message })
      }
    } catch (e: any) {
      reject({ message: e.message })
    }
  })
}
</script>

<style scoped lang="scss">
.station-info {
  margin-bottom: 16px;
  font-size: 14px;
  color: #333;
}
.tips-text {
  background-color: #f4f4f5;
  color: #909399;
  padding: 12px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.5;
  margin-bottom: 24px;
}
.inline-tips {
  margin-left: 12px;
  font-size: 13px;
  color: #909399;
}
</style>
